import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input
} from '@angular/core';
import { Supports } from '@polylearn/models';

@Component({
  selector: 'polylearn-support-view',
  templateUrl: './support-view.component.html',
  styleUrls: ['./support-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupportViewComponent implements OnInit {
  @Input() support: Supports;

  constructor() {}

  ngOnInit(): void {}
}
